var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4019 11.683C23.8311 12.1074 23.8349 12.7994 23.4105 13.2286C17.1054 19.604 6.82885 19.6497 0.455257 13.3464C0.0260964 12.922 0.0222592 12.23 0.446686 11.8008C0.871114 11.3717 1.56308 11.3678 1.99224 11.7923C7.50931 17.2485 16.4019 17.2069 21.8564 11.6916C22.2808 11.2624 22.9728 11.2586 23.4019 11.683Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.982 11.073C23.5841 11.1147 24.0384 11.6367 23.9967 12.2388L23.7125 16.3372C23.6708 16.9393 23.1488 17.3936 22.5466 17.3519C21.9445 17.3101 21.4902 16.7881 21.532 16.186L21.8161 12.0877C21.8579 11.4855 22.3798 11.0312 22.982 11.073Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7945 11.8157C17.8355 11.2135 18.3568 10.7585 18.959 10.7994L22.9808 11.0727C23.583 11.1136 24.038 11.6349 23.9971 12.2371C23.9562 12.8393 23.4349 13.2943 22.8327 13.2534L18.8109 12.9802C18.2087 12.9393 17.7536 12.4179 17.7945 11.8157Z",
    fill: "#0F20E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.589265 4.81362C6.89433 -1.56176 17.171 -1.60751 23.5446 4.69579C23.9737 5.12021 23.9776 5.81218 23.5532 6.24134C23.1287 6.6705 22.4368 6.67434 22.0076 6.24991C16.4905 0.793702 7.59783 0.835333 2.14339 6.35061C1.71897 6.77977 1.027 6.7836 0.597835 6.35918C0.168675 5.93475 0.164837 5.24278 0.589265 4.81362Z",
    fill: "#0F20E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45269 0.690162C2.05483 0.731912 2.50912 1.25389 2.46737 1.85603L2.18321 5.95437C2.14146 6.55651 1.61948 7.0108 1.01734 6.96905C0.415199 6.9273 -0.0390881 6.40532 0.00266204 5.80318L0.286824 1.70484C0.328574 1.1027 0.850551 0.648412 1.45269 0.690162Z",
    fill: "#0F20E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00255605 5.80402C0.0434657 5.20182 0.564808 4.7468 1.16701 4.78771L5.1889 5.06094C5.7911 5.10184 6.24612 5.62319 6.20521 6.22539C6.1643 6.82759 5.64296 7.2826 5.04076 7.24169L1.01886 6.96847C0.416661 6.92756 -0.0383536 6.40622 0.00255605 5.80402Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.d847f3546bd24ae4702d40cbd290d97d.svg";
export { ForwardRef as ReactComponent };